import { css } from "styled-components";
import { ThemeColor } from "../ThemeColors";
export const BorderSolidRed = css `
  border: 3px solid ${ThemeColor.lightred};
`;
